import WeekTooltipLabel from "./WeekTooltipLabel";
export default WeekTooltipLabel;
